var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('Menu',{ref:"menu",attrs:{"menu":_vm.labelsTree,"active":_vm.active}}),_c('Main',{attrs:{"menu":_vm.issuesTree,"active":_vm.active}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }